import 'css-chunksrc/client/scenes/workloads/graph/elementsOverlay/element/resizeable/styles.scss';export default {
  "resizeable": "_resizeable_1057y_1",
  "resizeHandler": "_resizeHandler_1057y_6",
  "resizeIcon": "_resizeIcon_1057y_21",
  "leftHandler": "_leftHandler_1057y_27",
  "rightHandler": "_rightHandler_1057y_31",
  "hovered": "_hovered_1057y_35"
};